import { AvenAdvisorBorrowingCapacityData } from 'aven_types'
import { BasePersonalFinancialStatementResource, PersonalFinancialStatementFetchOptions, PersonalFinancialStatementResourceType } from './basePersonalFinancialStatementResource'
import { calculateInitialBorrowingCapacity, getBorrowingCapacityData } from '../../../services/api'
import { inspect, log } from '@/utils/logger'

export class PersonalFinancialStatementBorrowingPowerResource extends BasePersonalFinancialStatementResource<PersonalFinancialStatementResourceType.BORROWING_POWER> {
    constructor() {
        super(PersonalFinancialStatementResourceType.BORROWING_POWER)
    }

    protected async fetchData(options?: PersonalFinancialStatementFetchOptions): Promise<AvenAdvisorBorrowingCapacityData | null> {
        if (options?.isNewUserInitialization) {
            const calcResponse = await calculateInitialBorrowingCapacity()
            log.info('PersonalFinancialStatementBorrowingPowerResource.fetchData: calculated initial borrowing capacity with calcResponse %{calcResponse}', { calcResponse: inspect(calcResponse) })
        }

        const response = await getBorrowingCapacityData()
        if (!response.data.success) {
            return null
        }

        return response.data.payload ?? null
    }
}
